export const USER_ROLE = {
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  INFRASTRUCTUREMANAGER: 'InfrastructureManager',
  MAINTAINER: 'Maintainer',
  INFRASTRUCTURETECHNICIAN: 'InfrastructureTechnician',
  TECHNICIAN: 'Technician',
  INTERNALSERVER: 'InternalServer',
  READONLY: 'ReadOnly'
}
export const DEFAULT_ROLES = [
  'Admin',
  'Manager',
  'InfrastructureManager',
  'Maintainer',
  'InfrastructureTechnician',
  'Technician',
  'InternalServer',
  'ReadOnly'
]
